import * as Sentry from '@sentry/nextjs';
import { AppProps } from 'next/app';
import { appWithTranslation } from 'next-i18next';

import '@/styles/globals.css';

import Layout from '@/components/layout/Layout';
import NotFound from '@/components/NotFound';

Sentry.setTag('app_branch', process.env.APP_BRANCH);

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={<NotFound />}
      onError={(error) => Sentry.captureException(error)}
    >
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </Sentry.ErrorBoundary>
  );
}

export default appWithTranslation(MyApp);
